import { useState, useEffect } from 'react';

interface UseLoadingOptions {
  duration?: number;
  initialState?: boolean;
}

export const useLoading = ({ 
  duration = 500, 
  initialState = true 
}: UseLoadingOptions = {}) => {
  const [loading, setLoading] = useState(initialState);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, duration);
    
    return () => clearTimeout(timer);
  }, [duration]);

  return { loading, setLoading };
};